import { change } from 'redux-form';
import { enableMargin, getMarginSettings } from '../actions/marginActions';
var initializedFromForm = function initializedFromForm(action) {
  return action.type === '@@redux-form/INITIALIZE' && action.meta.form === 'tradingStyle';
};
var marginCheck = false;
var authMiddleware = function authMiddleware(store) {
  return function (next) {
    return function (action) {
      var dispatch = store.dispatch,
        getState = store.getState;
      var _getState = getState(),
        _getState$user$userIn = _getState.user.userInfo,
        MarginBorrowerEnabled = _getState$user$userIn.MarginBorrowerEnabled,
        OMSId = _getState$user$userIn.OMSId,
        margin = _getState.margin;
      if (MarginBorrowerEnabled && (initializedFromForm(action) || action.type === 'RECEIVE_ACCOUNT')) {
        if (localStorage.getItem('tradingStyle') === 'Margin') {
          next(action);
          dispatch(enableMargin());
          dispatch(change('tradingStyle', 'tradingStyle', 'Margin'));
          return;
        }
      }

      /**
       * Only call this once to check if the endpoint exists on Gateway.
       * This is a decent proxy for if Margin is enabled by operator.
       */
      if (MarginBorrowerEnabled && !marginCheck && margin.accountState.settings.BasedAssetId === undefined) {
        marginCheck = true;
        dispatch(getMarginSettings(OMSId));
      }
      return next(action);
    };
  };
};
export default authMiddleware;